// extracted by mini-css-extract-plugin
export default {"backIcon":"AdminMobileUserRegister_backIcon__ByEJQ","regiBtn":"AdminMobileUserRegister_regiBtn__U74mi"};